import { Injectable } from '@angular/core';
import {
  HttpError,
  ErrorMessageResolver
} from '../../shared/models/http-error';
import {
  ErrorResponseMessageType,
  AppMessages,
  CacheConstant
} from '../constants/app.constant';
import { MessageService } from '../services/message.service';
import { AppCacheService } from '../services/cache/app-cache.service';
import { Router } from '@angular/router';
import { StaticService } from '../services/static/static.service';
import { DialogService } from '../services/dialog/dialog.service';
import { RoutePrefix } from '../constants/routes.constant';

@Injectable()
export class AppUtilService {
  /***************Properties***************/
  static router: Router;
  static cache: AppCacheService;
  static message: MessageService;
  static static: StaticService;
  static dialog: DialogService;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private router: Router,
    private cache: AppCacheService,
    private message: MessageService,
    private staticContent: StaticService,
    private dialogService: DialogService
  ) {
    AppUtilService.router = router;
    AppUtilService.message = message;
    AppUtilService.cache = cache;
    AppUtilService.static = staticContent;
    AppUtilService.dialog = dialogService;
  }
  /***************Constructor***************/

  /***************Utility Methods***************/

  static getBaseUrl() {
    return window.location.origin
      ? window.location.origin
      : window.location.protocol + '//' + window.location.host;
  }

  static redirectToHome() {
    const homeRoute =
      window.localStorage && window.localStorage[CacheConstant.User_Auth_Detail]
        ? RoutePrefix.MyHome
        : RoutePrefix.Home;
    const callBackUrl = AppUtilService.cache.get(CacheConstant.CallBackUrl)
    if (callBackUrl) {
      AppUtilService.router.navigate([callBackUrl]);
      AppUtilService.cache.remove(CacheConstant.CallBackUrl);
    }
    else {
      AppUtilService.router.navigate([homeRoute])
    }
  }

  static redirectToHomeMobile() {
    const callBackUrl = AppUtilService.cache.get(CacheConstant.CallBackUrl)
    if (callBackUrl) {
      AppUtilService.router.navigate([callBackUrl]);
      AppUtilService.cache.remove(CacheConstant.CallBackUrl);
    }
    else {
      AppUtilService.router.navigate(['/']);
    }
  }

  static redirectToExternalLink(url, isMobile: boolean = false) {
    const target = isMobile ? '_system' : '_blank';
    window.open(url, target);
  }

  static getHttpDefaultOptions() {
    return {
      headers: { ignoreLoadingBar: '' }
    };
  }

  static getUserSuffixId(username: string): string {
    const suffix = '@cardinalhealth.com';
    return username.toLowerCase().indexOf(suffix) === -1
      ? username + suffix
      : username;
  }

  static hasErrorCode(error: HttpError, errorCode: string): boolean {
    return error.faultInfos && error.faultInfos[0].faultCode === errorCode;
  }

  static resolveErrorResponse(
    error: HttpError,
    messageType: ErrorResponseMessageType = ErrorResponseMessageType.Page
  ): ErrorMessageResolver {
    const messageResolver: ErrorMessageResolver = {
      hasTypeMessage: false,
      messageText: AppMessages.GenericErrorMessage
    };

    if (error.faultInfos && error.messageDisplay === messageType) {
      messageResolver.hasTypeMessage = true;
      messageResolver.messageText = error.faultInfos[0].faultMessage;
    }

    return messageResolver;
  }

  static showGenericErrorMessage() {
    this.message.error(AppMessages.GenericErrorMessage);
  }

  static print(title: string, html: string, styles: string) {
    const printWindow = window.open();
    printWindow.document.title = title;
    printWindow.document.open();
    printWindow.document.write(
      '<!DOCTYPE html><html><head></head><body onload="window.print(); window.close()">' +
        '<style type="text/css">' +
        styles +
        '</style>' +
        html
    );
    printWindow.document.close();
    printWindow.focus();
  }

  static printOrderSummary(title: string, html: string, styles: string) {
    const printWindow = window.open();
    printWindow.document.title = title;
    printWindow.document.open();
    printWindow.document.write(
      '<!DOCTYPE html><html><head></head><body onload="window.print(); window.close()">' +
        '<style type="text/css" media="print">' +
        '@page {size: landscape}' +
        '</style>' +
        html
    );
    printWindow.document.close();
    printWindow.focus();
  }

  static isApple() {
    if (
      (navigator.userAgent.toLowerCase().indexOf('safari') !== -1 ||
        navigator.userAgent.toLowerCase().indexOf('iphone') !== -1) &&
      navigator.userAgent.toLowerCase().indexOf('chrome') === -1
    ) {
      return true;
    } else {
      return false;
    }
  }

  static isMobileApp() {
    if (this.isApple()) {
      if (!(navigator.userAgent.indexOf('Safari'))) {
        return true;
      } else {
        return false;
      }
    } else if (navigator.userAgent.indexOf('wv') > -1) {
      return true;
    } else {
      return false;
    }
  }

  static scrollTo(x: number = 0, y: number = 0) {
    window.scroll(x, y);
  }
  /***************Utility Methods***************/
}
